// 
import request from '../request'

export function fetchList() {
    return request({
        url: '/model-analysis/pipe/area/homepage/locations',
    })
}